export default class DeviceTypeService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/deviceType/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('me/deviceType/', params);
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/deviceType/' + id, params)
	}

	getEntitiesForSelectBox(params) {
		return this.apiService.callGet('me/deviceTypes/simple', params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/deviceTypes', params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/deviceType/' + id, params)
	}

	getDependency() {
		return this.apiService.callGet('me/deviceType/dependency/')
	}
}



// WEBPACK FOOTER //
// ./src/service/DeviceTypeService.js